var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[(_vm.label)?[_c('v-col',{attrs:{"cols":"1"}},[_c('v-divider',{staticClass:"grey lighten-1"})],1),_c('v-col',{staticClass:"text-h6 grey--text",attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])]:_vm._e(),_c('v-col',[_c('v-divider',{staticClass:"grey lighten-1"})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }